

import Iphone from "../image/IPhone17e.webp";
import SamPhone from "../image/GA16.webp";
import Pixel from "../image/Pixel9a.webp";

import Ipad from "../image/Ipad.webp";
import GTab from "../image/GTab.webp";
import Fire from "../image/Fire.webp";

import Iwatch from "../image/Iwatch.webp";
import Gwatch from "../image/GWatch.webp";
import Pixelwatch from "../image/Pixelwatch.webp";

import Icable from "../image/Icable.webp";
import Gcase from "../image/Gcase.webp";
import Pixelbuds from "../image/Pixelbuds.webp";


 const Phones = [
  {
    name: "iPhone 17e",
    img: Iphone,
    desc: "The latest and greatest from apple",
    price: "£599"
  },
  {
    name: "Samsung Galaxy A16",
    img: SamPhone,
    desc: "a reliable cheap phone ",
    price: "£139"
  },
  {
    name: "Google Pixel 9a",
    img: Pixel,
    desc: "The premier android phone",
    price: "£349"
  },
];



  const Tablets = [
  {
    name: "iPad Air M4",
    img: Ipad,
    desc: "an tablet powered by apples m4 chip ",
    price: "£599"
  },
  {
    name: "Galaxy Tab A11",
    img: GTab,
    desc: "a smooth experience optimised for entertainment ",
    price: "£189"
  },
  {
    name: "Amazon Fire HD 8",
    img: Fire,
    desc: "seamless on-the-go streaming and gaming ",
    price: "£79"
  },
];


  const Watch = [
  {
    name: "Apple Watch Ultra 3 ",
    img: Iwatch,
    desc: "an premium top of the line smart watch",
    price: "£599"
  },
  {
    name: "Samsung Galaxy Watch 8",
    img: Gwatch,
    desc: "A treat for the mind and the body.",
    price: "£319"
  },
  {
    name: "Google Pixel Watch 4",
    img: Pixelwatch,
    desc: "an exceptional smartwatch engineered by Google",
    price: "£399"
  },
];



  const Accessories  = [
  {
    name: "Apple USB C cable",
    img: Icable,
    desc: "an woven 240w charging cable ",
    price: "£29"
  },
  {
    name: "Samsung Galaxy A26 Case",
    img: Gcase,
    desc: "An ultra-thin and resilient case to protect your phone.",
    price: "£20"
  },
  {
    name: "Google Pixel Buds 2A",
    img: Pixelbuds,
    desc: "Wireless headphones that provide high qualty audio",
    price: "£129"
  },
];


export { 
  Phones,
  Tablets,
  Watch,
  Accessories,
};

  